module.exports = __webpack_public_path__ + "img/product-ketang-jm-05.66a9846c.png";